/* eslint-disable i18next/no-literal-string */
import React, { useContext } from 'react';
import { Fade, Modal, useMediaQueries } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import { ModelExplorationContext } from '../ModelExplorationContext';

const PopupContainer = ({ children, isOpen, onClose, dataTestId }) => {
  const { t } = useTranslation();
  const { isMobile } = useMediaQueries();
  const modelExplorationContext = useContext(ModelExplorationContext) || {};
  const { isDark } = modelExplorationContext;

  return (
    <Modal
      isOpen={isOpen}
      closeModal={onClose}
      hasNoPaddingX={isMobile}
      allowClose
      scrollElement={isMobile ? 'default' : 'wrapper'}
      closeAriaLabel={t('Shared.Common.pressToClosePopupAria')}
      isContainerNotScrollable={false}
      backgroundColor={isDark ? 'black' : 'white'}
      data-testid={dataTestId}
    >
      {() => <Fade>{children}</Fade>}
    </Modal>
  );
};

export default PopupContainer;
